module.exports = __webpack_public_path__ + "create-black-18dp.svg?2de08358659a7982fe1b2049fd519c45";